<template>
  <div>
    <div
      class="row-wrap d-flex align-items-center justify-content-between"
      v-for="info in infos"
      :key="info.id"
    >
      <router-link to="/admin/stakeholder-lists" class="p-3 text-dark">
        <span>{{ info.id }}. {{ info.title }}</span></router-link
      >
      <div class="icons">
        <router-link to="/admin/edit-stakeholder"><i class="fa fa-edit"></i></router-link>
        <i class="fa fa-trash" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'stakeholferRows',
  props: {
    infos: {
      type: Object,
    },
  },
};
</script>

<style scoped>
.row-wrap {
  border-bottom: 1px solid #eee;
  gap: 1rem;
  padding: 0.85rem 0;
}

.row-wrap a {
  min-width: 0;
  flex: 1 1 auto;
}

.row-wrap span {
  display: inline-block;
  white-space: normal;
  word-break: break-word;
}

.icons {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.fa {
  padding: 0px 20px 0px 0px;
  cursor: pointer;
}
.fa-edit {
  color: #2da047;
}
.fa-trash {
  color: red;
}

@media (max-width: 767px) {
  .row-wrap {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .row-wrap a {
    width: 100%;
    padding: 0 !important;
  }
}
</style>
